import { jsx as _jsx } from "react/jsx-runtime";
import { photoOfAsset } from '../../../common/network/attachment';
import PhotoFrame from './photo-frame';
// A house's photo in a small frame of a list, else an icon in its place.
const PhotoThumb = (props) => {
    var _a, _b;
    const photo = props.photo === null ? undefined : photoOfAsset(props.photo);
    return photo === undefined
        ? _jsx("span", { className: props.emptyClassName === undefined ? props.className : `${props.className} ${props.emptyClassName}`, "aria-hidden": "true", children: _jsx("i", { className: `bi ${(_a = props.icon) !== null && _a !== void 0 ? _a : 'bi-house'}` }) })
        : _jsx(PhotoFrame, { photo: photo, sizes: props.sizes, alt: (_b = props.alt) !== null && _b !== void 0 ? _b : '', className: props.className });
};
export default PhotoThumb;
